import React from 'react';
import Slider from "react-slick";

const ClintSay = ({review}) => {
    // const settings = {
    //     dots: true,
    //     infinite: true,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     speed: 2000,
    //     autoplaySpeed: 2000,
    //     cssEase: "linear",
    //   };
    return (
        <div>
              {/* <Slider {...settings}>
        <div>
          <h3>{review.name}</h3>
          <p>{review.text}</p>
        </div>
        <div>
          <h3>{review.name}</h3>
          <p>{review.text}</p>
        </div>
        
        
      </Slider> */}
        </div>
    );
};

export default ClintSay;